// Partner Site Templates Configuration
// Each template defines colors, layout style, and visual elements

export const PARTNER_TEMPLATES = {
  // Template 1: Clássico - Clean e profissional
  classic: {
    id: 'classic',
    name: 'Clássico',
    description: 'Design limpo e profissional, ideal para empresas tradicionais',
    preview: '/templates/classic-preview.png',
    tier: 'standard', // standard, premium
    price: 'Incluso no plano',
    styles: {
      // Hero
      heroBg: 'bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900',
      heroPattern: true,
      heroTextColor: 'text-white',
      heroAccent: 'text-blue-200',
      
      // Buttons
      primaryBtn: 'bg-green-500 hover:bg-green-600 text-white',
      secondaryBtn: 'bg-white/10 hover:bg-white/20 text-white border border-white/20',
      
      // Cards
      cardBg: 'bg-white',
      cardBorder: 'border border-gray-100',
      cardHover: 'hover:shadow-lg hover:-translate-y-1',
      
      // Tags/Badges
      tagPrimary: 'bg-blue-50 text-blue-700',
      tagSecondary: 'bg-gray-100 text-gray-700',
      tagSuccess: 'bg-green-50 text-green-700',
      
      // General
      pageBg: 'bg-gray-50',
      sectionBg: 'bg-white',
      priceColor: 'text-green-700',
      ratingColor: 'text-yellow-400',
    }
  },

  // Template 2: Moderno - Gradientes e animações
  modern: {
    id: 'modern',
    name: 'Moderno',
    description: 'Visual contemporâneo com gradientes vibrantes e efeitos',
    preview: '/templates/modern-preview.png',
    tier: 'standard',
    price: 'Incluso no plano',
    styles: {
      // Hero
      heroBg: 'bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600',
      heroPattern: true,
      heroTextColor: 'text-white',
      heroAccent: 'text-purple-200',
      
      // Buttons
      primaryBtn: 'bg-gradient-to-r from-pink-500 to-orange-500 hover:from-pink-600 hover:to-orange-600 text-white',
      secondaryBtn: 'bg-white/10 hover:bg-white/20 text-white border border-white/30 backdrop-blur',
      
      // Cards
      cardBg: 'bg-white/80 backdrop-blur',
      cardBorder: 'border border-purple-100',
      cardHover: 'hover:shadow-xl hover:shadow-purple-100 hover:-translate-y-2',
      
      // Tags/Badges
      tagPrimary: 'bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700',
      tagSecondary: 'bg-gray-100 text-gray-700',
      tagSuccess: 'bg-gradient-to-r from-green-100 to-emerald-100 text-green-700',
      
      // General
      pageBg: 'bg-gradient-to-b from-gray-50 to-purple-50',
      sectionBg: 'bg-white/50 backdrop-blur',
      priceColor: 'text-purple-700',
      ratingColor: 'text-amber-400',
    }
  },

  // Template 3: Minimalista - Foco nos produtos
  minimal: {
    id: 'minimal',
    name: 'Minimalista',
    description: 'Design simples com foco total nos produtos',
    preview: '/templates/minimal-preview.png',
    tier: 'standard',
    price: 'Incluso no plano',
    styles: {
      // Hero
      heroBg: 'bg-white',
      heroPattern: false,
      heroTextColor: 'text-gray-900',
      heroAccent: 'text-gray-500',
      
      // Buttons
      primaryBtn: 'bg-gray-900 hover:bg-gray-800 text-white',
      secondaryBtn: 'bg-white hover:bg-gray-50 text-gray-900 border border-gray-200',
      
      // Cards
      cardBg: 'bg-white',
      cardBorder: 'border border-gray-200',
      cardHover: 'hover:border-gray-300',
      
      // Tags/Badges
      tagPrimary: 'bg-gray-100 text-gray-800',
      tagSecondary: 'bg-gray-50 text-gray-600',
      tagSuccess: 'bg-gray-100 text-gray-800',
      
      // General
      pageBg: 'bg-white',
      sectionBg: 'bg-gray-50',
      priceColor: 'text-gray-900',
      ratingColor: 'text-gray-400',
    }
  },

  // Template 4: Vitrine - Estilo loja/e-commerce
  showcase: {
    id: 'showcase',
    name: 'Vitrine',
    description: 'Layout de loja virtual com destaque para produtos',
    preview: '/templates/showcase-preview.png',
    tier: 'standard',
    price: 'Incluso no plano',
    styles: {
      // Hero
      heroBg: 'bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600',
      heroPattern: true,
      heroTextColor: 'text-white',
      heroAccent: 'text-emerald-100',
      
      // Buttons
      primaryBtn: 'bg-orange-500 hover:bg-orange-600 text-white',
      secondaryBtn: 'bg-white hover:bg-gray-50 text-emerald-700 border-2 border-white',
      
      // Cards
      cardBg: 'bg-white',
      cardBorder: 'border-2 border-gray-100',
      cardHover: 'hover:border-emerald-300 hover:shadow-lg',
      
      // Tags/Badges
      tagPrimary: 'bg-emerald-50 text-emerald-700',
      tagSecondary: 'bg-orange-50 text-orange-700',
      tagSuccess: 'bg-teal-50 text-teal-700',
      
      // General
      pageBg: 'bg-gray-100',
      sectionBg: 'bg-white',
      priceColor: 'text-emerald-600',
      ratingColor: 'text-orange-400',
    }
  },

  // Template 5: Corporativo - Institucional e sério
  corporate: {
    id: 'corporate',
    name: 'Corporativo',
    description: 'Visual institucional para empresas B2B',
    preview: '/templates/corporate-preview.png',
    tier: 'standard',
    price: 'Incluso no plano',
    styles: {
      // Hero
      heroBg: 'bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800',
      heroPattern: true,
      heroTextColor: 'text-white',
      heroAccent: 'text-slate-300',
      
      // Buttons
      primaryBtn: 'bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold',
      secondaryBtn: 'bg-transparent hover:bg-white/10 text-white border-2 border-white/50',
      
      // Cards
      cardBg: 'bg-white',
      cardBorder: 'border border-slate-200',
      cardHover: 'hover:shadow-md',
      
      // Tags/Badges
      tagPrimary: 'bg-slate-100 text-slate-700',
      tagSecondary: 'bg-amber-50 text-amber-700',
      tagSuccess: 'bg-emerald-50 text-emerald-700',
      
      // General
      pageBg: 'bg-slate-50',
      sectionBg: 'bg-white',
      priceColor: 'text-slate-800',
      ratingColor: 'text-amber-500',
    }
  },

  // Template 6: Premium - Site Personalizado
  premium: {
    id: 'premium',
    name: 'Site Premium',
    description: 'Site 100% personalizado com design exclusivo, cores da sua marca e suporte dedicado',
    preview: '/templates/premium-preview.png',
    tier: 'premium',
    price: 'Consulte valores',
    features: [
      'Design exclusivo para sua marca',
      'Cores e fontes personalizadas',
      'Layout sob medida',
      'Domínio próprio (opcional)',
      'Suporte prioritário',
      'Consultoria de design',
      'Integrações especiais',
      'Relatórios avançados'
    ],
    styles: null // Custom - defined per client
  }
};

export const getTemplateById = (templateId) => {
  return PARTNER_TEMPLATES[templateId] || PARTNER_TEMPLATES.classic;
};

export const getAllTemplates = () => {
  return Object.values(PARTNER_TEMPLATES);
};

export const getStandardTemplates = () => {
  return Object.values(PARTNER_TEMPLATES).filter(t => t.tier === 'standard');
};

export const getPremiumTemplate = () => {
  return PARTNER_TEMPLATES.premium;
};
